import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import { TIRE_SET_INTRO_SAMPLE } from "ui/modules/fleet/tires/pages/TireSetEditCard/components/TireSetIntro/consts";

import { getMountOldSetWarehouse, getMountVehicle, TIRE_SET_MOUNT_INTRO_SAMPLE } from "../consts";
import { TireSetMountSceneProps } from "../types";

/** Korak "Stari set": zamjena na vozilu, stari set dobiva mjesto na skladištu. */
const MountOldSetScene: React.FC<TireSetMountSceneProps> = (props) => {
  const { currentSet, oldSetCode } = props;
  const vehicle = getMountVehicle(props);
  const warehouseName = getMountOldSetWarehouse(props);
  const newCode = currentSet.code || TIRE_SET_INTRO_SAMPLE.code;
  const oldCode = oldSetCode || TIRE_SET_MOUNT_INTRO_SAMPLE.oldSetCode;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="h-[7rem] rounded-md bg-gradient-to-br from-slate-50 to-slate-100 p-[10px]">
            <img src={vehicle.image} alt="" className="w-full h-full object-contain" />
          </div>
          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Zamjena guma</div>
          <div className="text-sm font-bold text-slate-800 truncate">{vehicle.name}</div>
          <div className="mt-2 space-y-2">
            <div className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
              <span className="text-slate-500">Skida se</span>
              <span className="px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-amber-100 text-amber-700 truncate">
                {oldCode}
              </span>
            </div>
            <div className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
              <span className="text-slate-500">Montira se</span>
              <span className="px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-emerald-100 text-emerald-700 truncate">
                {newCode}
              </span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Stari set ide u</div>
          <div className="text-xs font-bold text-slate-800 truncate">{warehouseName}</div>

          {/* Police skladišta: stari set dobiva svoje mjesto. */}
          <div className="mt-3 space-y-1.5">
            {["A", "B"].map((shelf) => (
              <div key={shelf} className="flex items-center gap-2">
                <span className="w-4 text-[0.6rem] font-semibold text-slate-400">{shelf}</span>
                <div className="flex flex-1 gap-1.5">
                  {[0, 1, 2, 3].map((slot) => {
                    const isOldSet = shelf === "A" && slot === 2;
                    return (
                      <span
                        key={slot}
                        className={
                          isOldSet
                            ? "flex-1 h-5 rounded-sm bg-amber-400 ring-2 ring-amber-200"
                            : "flex-1 h-5 rounded-sm bg-slate-100"
                        }
                      />
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Nijedan set se ne gubi"
          subtitle="Stari set odmah dobiva lokaciju"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(MountOldSetScene);
